<template>
  <moveable-container
    ref="movableContainer"
    :draggable="true"
    :resizable="isSelected"
    :rotatable="isSelected"
    :throttleResize="15"
    :throttleDrag="20"
    :snappble="true"
    :verticalGuidelines ="[0, 150, 200]"
    :horizontalGuidelines= "[0, 150, 200]"
    :class="[
    'moveable'
    ]      
    "
    tabindex="1"
    @drag="handleDrag"
    @dragEnd="handleDragEnd"
    @resize="handleResize"
    @rotate="handleRotate"
    @dragGroupStart="handleDraGroupStart"
    @dragGroup="handleDragGroup"
    :style="{
        position: 'fixed',
        display: 'flex',        
        top: `${content.y}px`,
        left: `${content.x}px`,
        zIndex: index,
        transform: content.transform,
        width: `${content.width || 200}px`,
        height: content.height ? `${content.height}px` : null,
    }"
  >
    <section
      ref="container"
      tabindex="0"
      :id="content.uuid"
      @key.27="handleEscape"
      @keyup.delete="handleDelete"
      @keyup.37="handleMoveLeft"
      @keyup.38="handleMoveUp"
      @keyup.39="handleMoveRight"
      @keyup.40="handleMoveDown"      
      :class="[
        'widget-container',
        'standalone',
        content.enterTransition ? 'animated' : '',
content.enterTransition  ? content.enterTransition : ''
      ]"
      :style="{
          fontFamily: content.mainFont,
          fontSize: `${content.mainFontSize}px`,
          flexDirection: 'column',
          display: 'flex',
          borderRadius: content.borderRadius ? content.borderRadius + '%' : '0%',
          justifyContent: content.valign ? content.valign === 'top' ? 'flex-start' : content.valign === 'bottom' ? 'flex-end' : 'center': 'center',
          textAlign: content.align,
          backgroundColor: (content.backgroundColor && content.backgroundColor.hexa) ? content.backgroundColor.hexa : null,
          color: (content.foreGroundColor && content.foreGroundColor.hexa) ? content.foreGroundColor.hexa : null,
          width: '100%',
          height: content.height ? '100%' : null
          }"
    >
      <div
        :class="{
           'edit-overlay':true,
            selected: isSelected            
      }"
      >

      </div>
      <slot></slot>
    </section>
  </moveable-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Hammer from "hammerjs";
import MoveableContainer from "vue-moveable";

export default {
  components: {
    MoveableContainer
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    action: {
      type: Function
    },
    index: {
      type: Number
    }
  },
  data() {
    return {
      x: this.content.x,
      y: this.content.y
    };
  },
  computed: {
    isSelected: {
      get: function() {
        return this.$store.state.editor.selectedComponent === this.content.uuid;
      }
    }
  },

  watch: {
    isSelected: function(value) {
      if (value) {
        this.$refs.container.focus();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let overlay = document.getElementById(this.content.uuid);

      let hammer = new Hammer(overlay, {});

      hammer.on("doubletap", e => {
        if (!this.isSelected) {
          this.selectComponent(this.content.uuid);
        }
        this.action(1);
      });
      hammer.on("tap", e => {
        console.log("seelct component");
        this.attachInlineEditor(null);
        this.selectComponent(this.content.uuid);
      });
    });
  },

  methods: {
    ...mapActions("editor", ["selectComponent", "attachInlineEditor"]),

    doSomething() {
      this.action(1);
    },

    handleEscape() {
      alert("esc");
    },
    triggerResizeEvent(x, y) {
      let target = this.$refs.movableContainer.$el;
      this.y = y;
      this.x = x;
      target.style.top = `${y}px`;
      target.style.left = `${x}px`;
      window.dispatchEvent(new Event("resize"));
    },

    handleMoveUp() {
      this.triggerResizeEvent(this.x, this.y - 1);
    },
    handleMoveDown() {
      this.triggerResizeEvent(this.x, this.y + 1);
    },
    handleMoveLeft() {
      this.triggerResizeEvent(this.x - 1, this.y);
    },
    handleMoveRight() {
      this.triggerResizeEvent(this.x + 1, this.y);
    },
    handleDrag({ target, left, top }) {
      target.style.left = `${left}px`;
      target.style.top = `${top}px`;
      this.x = left;
      this.y = top;
    },

    handleDragEnd({ target, isDrag, clientX, clientY }) {
      console.log("handle drag end " + this.y);
      console.log(target);
      let data = {
        x: this.x,
        y: this.y
      };
      this.$emit("moveEnd", data);
    },

    handleResize({ target, width, height, delta }) {
      delta[0] && (target.style.width = `${width}px`);
      delta[1] && (target.style.height = `${height}px`);
      let data = {
        width,
        height
      };
      this.$emit("resize", data);
    },

    handleRotate({ target, dist, transform }) {
      let data = {
        transform
      };
      this.$emit("rotate", data);
    },

    handleDraGroupStart({ targets }) {
      console.log("on drag gorup stat", targets);
    },

    handleDragGroup({ targets }) {
      console.log("onDragGroup", targets);
    },

    handleDelete() {
      this.selectComponent(null);
      this.$emit("delete", this.content.uuid);
    }
  }
};
</script>

<style lang="scss">

.widget-container {
  transition: all .2s ease-in;
  overflow: hidden;
  
}
.moveable {
  .container {
    z-index: 9000;
  }
  .edit-overlay {
    align-items: center;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    position: absolute;
    &:focus {
      background: red;
    }

    width: calc(100% + 4px);
    height: calc(100% + 4px);
    top: -1px;
    left: -1px;
    z-index: 3000;
    background: none;

    &.selected {
      border: 2px solid #4af;
    }

    .edit-overlay__content {
    }
  }
}

.moveable-line {
}
</style>